/**
 * Preferencia de formato de exibicao da listagem de pedidos.
 *
 * A chave NAO pode conter "muven-": o interceptor de autenticacao
 * (src/auth/interceptors/registerAuthInterceptor.ts) injeta como header HTTP toda chave
 * de localStorage que casa com /muven-/.
 *
 * Nada limpa essa chave - o logout so remove `muven-client-id` e a expiracao de token so
 * reescreve `authorization` -, entao a preferencia sobrevive a expiracao de sessao e nao
 * tem vinculo com a conta: e por navegador.
 */
const ORDER_LIST_VIEW_MODE = 'order-list-view-mode'

export const VIEW_MODE_TIMELINE = 'timeline'
export const VIEW_MODE_FLAT = 'flat'
export const VIEW_MODES = [VIEW_MODE_TIMELINE, VIEW_MODE_FLAT]

function defaultViewMode():string {
    return VIEW_MODE_TIMELINE
}

function isValid(viewMode:any):boolean {
    return VIEW_MODES.indexOf(viewMode) !== -1
}

export default {
    getViewMode():string {
        try {
            const stored = localStorage.getItem(ORDER_LIST_VIEW_MODE)

            if (!isValid(stored)) {
                return defaultViewMode()
            }

            return stored as string
        } catch (e) {
            // storage indisponivel (modo privado, storage bloqueado) nunca pode quebrar a tela
            return defaultViewMode()
        }
    },
    setViewMode(viewMode:string):void {
        if (!isValid(viewMode)) {
            return
        }

        try {
            localStorage.setItem(ORDER_LIST_VIEW_MODE, viewMode)
        } catch (e) {
            // sem persistencia a tela continua funcionando, so nao lembra da escolha
        }
    },
}
